
import React, { useState, useEffect } from "react";
import ReportListContainer from "./reports/ReportListContainer";
import { ReportMapView } from "./reports/ReportMapView";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Map, List } from "lucide-react";
import { useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/components/ui/use-toast";
import { useReportFilters } from "@/hooks/report-filters";
import { useLocalStorage } from "../hooks/useLocalStorage";

interface ReportListProps {
  searchTerm: string;
}

const ReportList = ({ searchTerm }: ReportListProps) => {
  const [view, setView] = useLocalStorage<"list" | "map">("userPref_viewMode", "list");
  const { toast } = useToast();
  const queryClient = useQueryClient();

  // Utiliser le hook des filtres
  const {
    selectedCategory,
    sortBy,
    sortOrder,
    filteredReports,
    handleCategoryChange,
    handleSortChange
  } = useReportFilters({ searchTerm, queryClient, toast });
  
  // Mettre à jour le localStorage lorsque la vue change
  const handleViewChange = (value: string) => {
    setView(value as "list" | "map");
  };

  return (
    <div>
      <Tabs defaultValue={view} onValueChange={handleViewChange}>
        <TabsList className="grid w-full grid-cols-2 mb-6">
          <TabsTrigger value="list" className="flex items-center gap-2">
            <List className="h-4 w-4" />
            Liste
          </TabsTrigger>
          <TabsTrigger value="map" className="flex items-center gap-2">
            <Map className="h-4 w-4" />
            Carte
          </TabsTrigger>
        </TabsList>
        
        <TabsContent value="list">
          <ReportListContainer searchTerm={searchTerm} />
        </TabsContent>
        
        <TabsContent value="map">
          <ReportMapView 
            reports={filteredReports}
            selectedCategory={selectedCategory}
            onCategoryChange={handleCategoryChange}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSortChange={handleSortChange}
          />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default ReportList;
